export default __webpack_public_path__ + "static/media/JP.b2653834.svg";